import axios from 'axios';

const BASE_URL = 'https://cinequilt.onrender.com/api/v1/';

export default axios.create({
    baseURL: 'https://cinequilt.onrender.com/api/v1/',
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});